export { MarkerService } from './lib/marker.service';
export * from './lib/shared-map-feature-map.module';
